<template>
  <el-select
    v-bind="$attrs"
    v-model="selectedValue"
    filterable
    clearable
    :placeholder="placeholder"
    v-on="$listeners"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    />
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </el-select>
</template>

<script>
  import { getCrmEnum } from '@/api/crm/label.js'
  export default {
    name: 'YdLabelSelect', // 标签选择
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      }
    },
    data() {
      return {
        options: []
      }
    },
    computed: {
      selectedValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        const { code, data } = await getCrmEnum()
        if (code !== 0) {
          return
        }
        this.options = data && data.tag ? data.tag : []
      }
    }
  }
</script>

<style lang="scss" scoped></style>
